// es6 polyfills required for IE11
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import 'unfetch/polyfill';
import 'core-js/es/string';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { fromJS } from 'immutable';
// import { Route, HashRouter } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './services/store';
import * as serviceWorker from './serviceWorker';
import AppHOC from './components/AppHOC';
import App from './components/App';

import debug from './services/debug';

if (process.env.REACT_APP_DEBUG_STORE === 'true') {
    const listenToStore = () => {
        const state = fromJS(store.getState());
        debug('Redux Store Changed', state.toJS());
    };

    store.subscribe(listenToStore);
}

ReactDOM.render(

    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Route path="/" component={AppHOC(App)} />
        </ConnectedRouter>
    </Provider>,

    document.getElementById('reasons-why-app'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
